import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles, Theme } from '@dxb-web-ui-framework/design-system';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { PayrollDetails } from '../../domain/Payroll/entities/types';
import { BaseTransactionsDetails } from './BaseTransactionsDetails';
import { TransactionsDetails } from './TransactionDetails';
import { Modifications } from './Modifications';

const useStyles = makeStyles<Theme>(({ spacing, breakpoints }) => ({
  fullHeight: {
    height: '100%',
  },
}));

type GenericPayrollInformationProps = {
  payrollDetails: Nullable<PayrollDetails>;
  isLoading: boolean;
};

const GenericPayrollInformation: FC<GenericPayrollInformationProps> = ({ payrollDetails, isLoading }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.fullHeight} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
      <BaseTransactionsDetails payrollDetails={payrollDetails} isLoading={isLoading} t={t} />
      <TransactionsDetails payrollDetails={payrollDetails} isLoading={isLoading} t={t} />
      <Modifications payrollDetails={payrollDetails} isLoading={isLoading} t={t} />
    </Box>
  );
};

export { GenericPayrollInformation };
